import { Component, OnInit } from '@angular/core';
import { Loadable } from '@fenix/shared';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidacionClienteService } from '../../../services/validacion-cliente.service';
import { Subscription } from 'rxjs';
import { RequestValidacionRespuestas } from '../../../domains/request-validacion-respuestas';
import { Respuesta } from '../../../domains/respuesta';
import { Token } from '../../../domains/token';
import { CONFIG_URL_CAPTCHA } from '../../../constants/lottie.constants';
import { CONFIG } from '../../../constants/lottie.constants';
import { AnalyticsService } from '../../../services/analytics.service';
import { CatalogoMensaje } from '../../../constants/catalogo';
import { AuthGuard } from '../../../guard/auth.guard';
import { ERRORES } from '../../../constants/errores.constants';
import { AnalyticsConstants } from '../../../constants/googleAnalytics';
@Component({
  selector: 'app-preguntas',
  templateUrl: './preguntas.component.html',
  styleUrls: ['./preguntas.component.scss']
})
export class PreguntasComponent implements OnInit {
  private readonly subs = new Subscription();
  privacidad: string;
  condiciones: string;
  preguntas = new Loadable<any>();
  map = new Map();
  preguntaRespuesta;
  requestValidacionRespuestas: RequestValidacionRespuestas;
  answers: Respuesta[] = [];
  token: Token;
  cuestionarioPreguntas = true;
  form: FormGroup;
  loadingComponent = false;
  load = false;
  anyTypeError;
  titulo: string;
  mensaje: string;
  buttonContinuar = {
    text: 'CONTINUAR',
    class: 'btn-primary',
    type: 'button'
  };
  buttonReintentar = {
    text: 'REINTENTAR',
    class: 'btn-neutral',
    type: 'button'
  };
  lottieInfo = CONFIG.WARN;
  constructor(
    private readonly router: Router,
    private readonly fb: FormBuilder,
    private readonly validacionClienteService: ValidacionClienteService,
    private readonly analyticsService: AnalyticsService,
    private readonly authGuard: AuthGuard
  ) {
    this.privacidad = CONFIG_URL_CAPTCHA.url_captcha_privacy;
    this.condiciones = CONFIG_URL_CAPTCHA.url_captcha_terms;
    this.authGuard.setActivated = false;
  }
  ngOnInit(): void {
    this.analyticsService.pageView({
      screen_name: 'estado de situacion :: preguntas'
    });
    this.dataPreguntas();
    this.initForm();
  }
  radioChange(event, i) {
    this.map.set(i, event);
  }
  sendPreguntas() {
    this.analyticsService.btnClick({
      label: 'continuar',
      action: 'click',
      channel: AnalyticsConstants.chanel,
      element_id: undefined,
      type: 'button',
      section: 'preguntas'
    });
    this.cuestionarioPreguntas = false;
    this.loadingComponent = true;
    this.load = true;
    this.setValueForm();
    const sub = this.validacionClienteService
      .validarRespuestas(this.requestValidacionRespuestas)
      .subscribe(
        (data) => {
          this.load = false;
          this.loadingComponent = false;
          this.authGuard.setActivated = true;
          this.validacionClienteService.cifrado = data.userToken;
          this.router.navigate(['estado-situacion/exito']);
        },
        (error) => {
          const errorPreguntas = error.error;
          this.load = false;
          this.loadingComponent = false;
          if (errorPreguntas.error === 'OA8006') {
            this.titulo = ERRORES['error-preguntas'].titulo;
            this.mensaje = ERRORES['error-preguntas'].mensaje;
            this.anyTypeError = 'invalidAnswer';
            this.analyticsService.mensaje({
              label: errorPreguntas.mensaje,
              action: 'view',
              channel: AnalyticsConstants.chanel,
              element_id: undefined,
              type: AnalyticsConstants.alertWarning,
              section: 'preguntas'
            });
          } else if (errorPreguntas.error === 'OA1017') {
            this.titulo = ERRORES['max-intentos'].titulo;
            this.mensaje = ERRORES['max-intentos'].mensaje;
            this.anyTypeError = 'bloqueoIntentos';
            this.analyticsService.mensaje({
              label: errorPreguntas.mensaje,
              action: 'view',
              channel: AnalyticsConstants.chanel,
              element_id: undefined,
              type: AnalyticsConstants.alertWarning,
              section: 'preguntas'
            });
          } else {
            this.pushAnalyticsIntermitencia();
          }
        }
      );
    this.subs.add(sub);
  }
  pushAnalyticsIntermitencia() {
    this.titulo = ERRORES['intermitencia'].titulo;
    this.mensaje = ERRORES['intermitencia'].mensaje;
    this.anyTypeError = 'intermitencia';
    this.analyticsService.mensaje({
      label: CatalogoMensaje.AnalyticsMensajeIntermitencia,
      action: 'view',
      channel: AnalyticsConstants.chanel,
      element_id: undefined,
      type: AnalyticsConstants.alertWarning,
      section: 'preguntas'
    });
  }
  private initForm() {
    const questions = this.preguntas.data.question;
    const formModel = {};
    questions.forEach((question) => {
      formModel[question.questionId] = this.fb.control('', Validators.required);
    });
    this.form = this.fb.group(formModel);
  }
  setValueForm() {
    this.map.forEach((value: number, key: number) => {
      this.preguntaRespuesta = {
        answerId: value,
        questionId: key
      };
      this.answers.push(this.preguntaRespuesta);
    });
    this.token = {
      accessToken: this.preguntas.data.token,
      refreshToken: this.preguntas.data.refreshToken
    };

    this.requestValidacionRespuestas = {
      rut: this.preguntas.data.rut,
      answers: this.answers,
      transactionKey: this.preguntas.data.transactionKey,
      token: this.token,
      userToken: this.preguntas.data.userToken
    };
  }
  dataPreguntas() {
    this.preguntas.data = this.validacionClienteService.getPreguntas();
  }
  reintentar() {
    this.analyticsService.btnClick({
      label: 'reintentar',
      action: 'click',
      channel: AnalyticsConstants.chanel,
      element_id: undefined,
      type: 'button',
      section: 'preguntas'
    });
    this.authGuard.setActivated = true;
    this.router.navigate(['estado-situacion/login-eess']);
  }
}
